import React, { FC, useEffect, useState } from 'react'
import { Skeleton } from '../../../src/content/Skeleton/Skeleton'
import { useToggleEmailPreference } from '../hooks/useEmailPreferenceData'
import { EmailPreferenceItem } from './PreferenceSection'
import {
    StyledPreferenceCard,
    StyledToggleButton,
} from './PreferenceSection.styled'

interface PreferenceCardProps {
    item: EmailPreferenceItem
    isLoading: boolean
}

export const PreferenceCard: FC<PreferenceCardProps> = ({
    item,
    isLoading,
}) => {
    const [checked, setChecked] = useState<boolean>(false)
    useEffect(() => {
        setChecked(!!item.optIn)
    }, [item.optIn])
    const {
        mutate,
        isLoading: isUpdating,
        isError,
        isSuccess,
        data,
        reset,
    } = useToggleEmailPreference({ optIn: !checked })

    if (isSuccess) {
        setChecked((checked) => !checked)
        reset()
    }

    return (
        <StyledPreferenceCard>
            <div>
                <small>{item.frequency}</small>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
            </div>
            <div>
                <small>Opt-in</small>
                {isLoading ? (
                    <Skeleton height={40} width={100} />
                ) : (
                    <StyledToggleButton
                        on="yes"
                        off="no"
                        checked={checked}
                        onToggle={() => {
                            mutate()
                        }}
                        disabled={isUpdating}
                    />
                )}
                {isError && <small>Error occurs</small>}
            </div>
        </StyledPreferenceCard>
    )
}
